import React, { useCallback, useEffect, useMemo, useState } from "react";
import { apiStore } from "../../../api/ApiFactory";
import { Grid, Chip } from "@mui/material";
import { MainCard } from "../../../components/surface/MainCard";
import { ReactTable } from "../../../components/table/ReactTable";
import { Column, TableInstance } from "react-table";
import { IMotor } from "../../../models/Configuration";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getLookupsDetails } from "../../../store/slices/BoatOrdering/BoatOrderingSelector";
import { SelectColumnFilter } from "../../../components/table/filters/SelectColumnFilter";

const MotorList = () => {
  const [tableData, setTableData] = useState([]);
  const [preRigsList, setPrerigsList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  const lookups = useSelector(getLookupsDetails);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      const result = apiStore.boatOrderingApi.getLookups(false);
      const preRigsListResult = apiStore.boatOrderingApi.getPrerigList();
      /*
      result.then((response) => {
        setTableData(response);
      });
      */
      preRigsListResult.then((response) => {
        setPrerigsList(response);
      });
    }
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (lookups !== null) {
      setTableData(
        lookups.motorList.filter((item: any) => item.isLooseMotorActive == true)
      );
    }
  }, [lookups]);

  const showPrerig = (value: any) => (
    <Grid container spacing={1} direction="row">
      {value.map((prerig: { name: string; value: string }, index: number) => (
        <Grid item key={index}>
          <Chip label={prerig.name} />
        </Grid>
      ))}
    </Grid>
  );

  const columns: Column<IMotor>[] = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Part Num",
        accessor: "partNumber",
      },
      {
        Header: "Price",
        accessor: "price",
      },
      {
        Header: "Horsepower",
        accessor: "horsepower",
      },
      {
        Header: "Pre-Rig",
        accessor: "preRigs",
        Cell: (cell: any) => <div>{showPrerig(cell.value)}</div>,
        width: 300,
        maxWidth: 300,
        //Filter: SelectColumnFilter,
      },
    ],
    []
  );

  const onAddToCart = useCallback(
    (instance: TableInstance<IMotor>) => () => {
      const { partNumber } = instance.selectedFlatRows[0].original;
      navigate(`/boat/order/motor/${partNumber}`);
    },
    []
  );

  return (
    <>
      {tableData.length == 0 ? (
        <p>Loading..</p>
      ) : (
        <Grid container>
          <Grid item md={12} xs={12}>
            <MainCard title="Motor">
              <ReactTable<IMotor>
                name="shipping-lookups-table"
                serverOnChange={false}
                columns={columns}
                data={tableData ? tableData : []}
                isLoading={false}
                onAddToCart={onAddToCart}
              />
            </MainCard>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default MotorList;
